function initListeners() {
  const listItem = document.querySelectorAll('.productGrid .list-menu__item');
  const listLabel = document.querySelectorAll('.productGrid .list-menu__item .facet-checkbox');
  const listLabelMob = document.querySelectorAll('.productGrid .list-menu__item .mobile-facets__label');

  listItem.forEach(el => {
    el.addEventListener('click', () => {
      changeFilter();
    })
  });

  function changeFilter() {
    listLabel.forEach(elem => {
      const input = elem.querySelector('input[type=checkbox]:checked');

      if (elem.classList.contains('facet-checkbox--disabled')) {
        elem.parentNode.classList.add('inactive');
      }

      if (input) {
        elem.parentNode.classList.add('selected');
      } else {
        elem.parentNode.classList.remove('selected');
      }
    });

    listLabelMob.forEach(elem => {
      const input = elem.querySelector('input[type=checkbox]:checked');

      if (elem.classList.contains('mobile-facets__label--disabled')) {
        elem.parentNode.classList.add('inactive');
      }

      if (input) {
        elem.parentNode.classList.add('selected');
      } else {
        elem.parentNode.classList.remove('selected');
      }
    });
  }

  changeFilter();
}

function initToggleMobileFilterButtons() {
  const mobileFilterCheckboxes = document.querySelectorAll('.mobile-facets .mobile-facets__checkbox');

  mobileFilterCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', toggleMobileFilterButtons);
  });

  function toggleMobileFilterButtons(e) {
    const currentSubmenu = e.currentTarget.closest('.mobile-facets__submenu');
    const currentFooter = currentSubmenu.querySelector('.mobile-facets__footer');
    const activeInputs = currentSubmenu.querySelectorAll('input:checked');

    if (activeInputs.length) {
      currentFooter.classList.remove('mobile-facets__footer--disabled');
    } else {
      currentFooter.classList.add('mobile-facets__footer--disabled');
    }
  }
}

function initAddToCart() {
  const addToCartHandlers = document.querySelectorAll('.product-grid .js-add-to-cart');

  addToCartHandlers.forEach((handler) => {
    handler.addEventListener('click', (e) => {
      const target = e.currentTarget;

      window.handlers['addProduct'](target.dataset.id);
    });
  });
}

initToggleMobileFilterButtons();
initAddToCart();
